export default function AppSettings({ mojitoTools: { config } }) {
    return !config.hide && <div className="ta-AppSettings" />;
}
